require('common/js/directive/focus-directive');
require('common/js/directive/tips-directive');



// WEBPACK FOOTER //
// ./src/common/js/directive/all-directive.js